import { CommonModule } from '@angular/common';
import {  Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SettingsService } from '@delon/theme';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { DateFormatService } from 'src/app/shared/services/date-format.service';
import { MomentService } from 'src/app/shared/services/moment.service';
@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, NzDatePickerModule],
  styleUrls: ['./date-range.component.less']
})
export class DateRangeComponent {
  private momentService = inject(MomentService);
  private _from: any;

  get country() {
    return this.settings.user['company'].country;
  }

  dateFormat() {
    return this.format ?? this.dateFormatService.currentDateFormatValue;
  }

  @Input() disabledDate: (d: Date) => boolean = () => false;
  @Input() allowClear: boolean = true;
  @Input() format?: string;

  @Input() get from() {
    return this._from;
  }

  set from(value) {
    this._from = value ? this.momentService.moment(value).startOf('day').toDate() : null;
    if (this._from && this._to) {
      this._dates = [this._from, this._to];
    }
  }

  private _to: any;
  @Input() get to() {
    return this._to;
  }

  set to(value) {
    this._to = value ? this.momentService.moment(value).startOf('day').toDate() : null;
    if (this._from && this._to) {
      this._dates = [this._from, this._to];
    }
  }

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  private _dates: any[] = [];
  get dates() {
    return this._dates;
  }

  set dates(value: any[]) {
    if (value?.length) {
      this._from = value[0];
      this._to = value[1];
    } else {
      this._from = null;
      this._to = null;
      this._dates = [];
    }

    this.fromChange.emit(this.from);
    this.toChange.emit(this.to);
  }

  constructor(
    private settings: SettingsService,
    private dateFormatService: DateFormatService
  ) {}
}
